import { IPostTemplateMailUploadRequest } from "../../../interfaces/api/ITemplateMails";

export default class PostTemplateMailUploadRequest implements IPostTemplateMailUploadRequest {
    file: File;
    type: string;
    subject: string;
    client_types: string[];
    date_validity_start: string;
    date_validity_end: string;
    status: string;
    description: string;

    constructor(data: IPostTemplateMailUploadRequest) {
        this.file = data.file;
        this.type = data.type;
        this.subject = data.subject;
        this.client_types = data.client_types;
        this.date_validity_start = data.date_validity_start? data.date_validity_start : "";
        this.date_validity_end = data.date_validity_end? data.date_validity_end : "";
        this.status = data.status;
        this.description = data.description;
    }
}